<template>
    <div class="BomPartObjectFormComponent">


        {{lang.label_PartNumber}}:
        <!-- <b-form-input size="sm" class="form-control" v-model="form.partNumber" type="text"></b-form-input> -->
        <b-input-group size="sm">
            <b-form-input type="text" v-model="form.partNumber"></b-form-input>
            <b-input-group-append>
                <b-button @click="SelectFromList"  :variant="variant">Select from list</b-button>
        
            </b-input-group-append>
        </b-input-group>
        <br>
        {{lang.label_Revision}}:
        <b-form-input 
            size="sm" 
            class="form-control" 
            v-model="form.revision" 
            type="text" 
            aria-describedby="input-Revision-feedback"
            :state="validation_Revision"
            ></b-form-input>
        <b-form-invalid-feedback id="input-Revision-feedback" :state="validation_Revision">
            {{lang.validinfo_Revision}}
        </b-form-invalid-feedback>
        <br>
        {{lang.label_PartReference}}:
        <!-- <b-form-input size="sm" class="form-control" v-model="form.partReference" type="text"></b-form-input> -->
        <b-form-textarea v-model="form.partReference" rows="3" max-rows="6" size="sm"
            class="form-control" :disabled="isUpdate"></b-form-textarea>
        <br>
        {{lang.label_Description}}:
        <b-form-textarea id="textareaDescriptionBom" v-model="form.description" rows="3" max-rows="6" size="sm" class="form-control"></b-form-textarea>



    </div>
</template>

<script>


export default {
    name: "BomPartObjectFormComponent",
    components: {



    },
    props: {
        lang: Object,
        data: Object
    },
    data() {
        return {
            form: {
                
                partNumber: "",
                revision: "",
                partReference: "",
                description: ""
        
            },
            
        }
    },
    computed: {
        validation_Revision() {
            
            return (this.form.revision % 1) == 0;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        bomPartObjectForm(){
            return this.$store.getters.bomPartObjectForm;
        },
        isUpdate() {
            return this.data.source == "update";
        }
    },
    created() {
        
        if (this.data.source == "update") {
            this.form = this.data.form;
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_bomPartObjectForm", this.form);
        
    },
    updated() {

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_bomPartObjectForm", this.form);

    },
    watch: {
        bomPartObjectForm: function (newVal, oldVal) {
            
            this.form.partNumber = newVal.partNumber;
            this.form.revision = newVal.revision;
            this.form.description = newVal.description;
        }
    },
    methods: {
        SelectFromList() {
            
            let vue = this;

            function funcYes(vue) {

                let description = vue.$store.getters.selectedSearchPartRows.description;
                if (vue.$store.getters.selectedSearchPartRows.description == null) {
                    description = "";
                }
                
                const bomPartObjectForm = vue.$store.getters.bomPartObjectForm;
                bomPartObjectForm.partNumber = vue.$store.getters.selectedSearchPartRows.partNumber;
                bomPartObjectForm.revision = vue.$store.getters.selectedSearchPartRows.revision;
                bomPartObjectForm.description = description;
                
                vue.$store.dispatch("projm_bomPartObjectForm", bomPartObjectForm)
            }

            let data = {
                form: vue.form,
                isCheckBoxShowAll: vue.form.partNumber != ""
            }

            var obj = {

                text: "",
                type: "bom",
                buttons: 2,
                size: "xxl",
                data: data,
                lang: this.lang.modal_SearchParts,
                funcNo: "",
                funcYes: funcYes
            };
            this.$store.dispatch("showModalSearchPartsComponent", obj);


        }
    }
}
</script>
<style lang="scss">
.BomPartObjectFormComponent {

}
</style>



// WEBPACK FOOTER //
// src/components/shared/BomPartObjectFormComponent.vue